import { UserInfo } from '../../modules/shared/interfaces/user/user-info.interface';

export interface AuthState {
    userInfo: UserInfo;
}

export const initialState: AuthState = {
  userInfo: null
};
